<template>
  <div class="appointmentTabs">
    <Tabs v-model="activeTab" :sections="tabSections">
      <MakeChangesTab
        v-if="activeTab === TabNames.makeChanges"
        v-bind="props"
      />
      <ShareAppointmentTab v-if="activeTab === TabNames.share" v-bind="props" />
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { Appointment } from "serviceshift-ui/shared/src/typings/appointment";
import { Job } from "serviceshift-ui/shared/src/typings/job";
import { computed, ref } from "vue";
import { useStore } from "@/lib/vuex-composition";

import MakeChangesTab from "@/components/Appointment/tabs/MakeChangesTab.vue";
import ShareAppointmentTab from "@/components/Appointment/tabs/ShareAppointmentTab.vue";
import Tabs from "@/components/Tabs.vue";

const store = useStore();
const props = defineProps({
  isCustomer: {
    type: Boolean,
    default: () => false
  },
  appointment: {
    type: Object as () => Appointment,
    default: () => null
  },
  job: {
    type: Object as () => Job,
    default: () => null
  }
});

enum TabNames {
  makeChanges = "Make Changes",
  share = "Share Appointment"
}

const activeTab = ref<TabNames | null>(null);

const tabSections = computed(() => {
  if (
    props.isCustomer &&
    (props.job.invoice?.billing_customer?.customer_id ===
      store.state.user?.id ||
      store.state.user?.handles_billing)
  )
    return [TabNames.makeChanges, TabNames.share];
  return [TabNames.share];
});
</script>

<style lang="scss" scoped>
.tabs {
  font-size: 14px;
  background: #fff;
  .tab {
    background: #eeeeee;
    padding: 8px;
    flex: 1;
    &:not(:first-child) {
      margin-left: 1px;
    }
  }
}
</style>
